import { request } from '@max/meituan-uni-network';
//const baseURL = 'http://api.hotel.test.sankuai.com/';
const baseURL = 'https://apihotel.meituan.com/';
const requestDataCenter = (componentRequestParams) => {
    var _a, _b;
    const { componentProps, requestParams, comboCallback } = componentRequestParams;
    const { moduleVersion, moduleType, _runtimeInfo, userInfo } = componentProps;
    const commonParams = _runtimeInfo === null || _runtimeInfo === void 0 ? void 0 : _runtimeInfo.commonParams;
    const cityId = (_b = (_a = commonParams === null || commonParams === void 0 ? void 0 : commonParams.cityInfo) === null || _a === void 0 ? void 0 : _a.cityId) !== null && _b !== void 0 ? _b : 1;
    // 画布中组件的uid
    const mid = 'comp_6d165570-f5c3-496c-aede-cb952ec0961b';
    return new Promise((resolve, reject) => {
        request({
            // url: `${requestParams.devBasePath}datacenter/query/page/data?gps_cityid=1&source=mt&cn_pt=RN&token=AgFKJawsLdBR7kJeR0UrVvOakQOi7PcB6JFV4q27F-w6TkvMsj64SjsIFyl9gbU1Nsx53q739sjVaAAAAABrZwcAwl9uOquBblpXEfmP7x8s3mw7UV3D4ePCps3MTbAdjOgypLwS_movvifdbKHM9TvU&client=android&version=12.11.200&osversion=12&strategy=0&isPtest=false&utm_source=meituaninternaltest&utm_medium=android&utm_term=1200110200&version_name=12.11.200&utm_content=172da76925664c6a93dc0fca38276121a168717193035679940&utm_campaign=AgroupBgroupC0D200E0Ghomepage&ci=1&msid=172da76925664c6a93dc0fca38276121a1687171930356799401688106855010&uuid=00000000000004882F2FA968B4BB29EF2D8A3DEA0300CA168717193049753060&userid=5087170136&p_appid=10&__reqTraceID=ef39a39f-9bf5-4408-aaa2-fbc2ffb76b94&csecplatform=1&csecversionname=12.11.200&csecpkgname=com.sankuai.meituan&csecversion=1.0.0.36`,
            url: `${baseURL}flagship/data/center/datacenter/query/page/data?isPtest=true&userid=${userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId}&token=${userInfo === null || userInfo === void 0 ? void 0 : userInfo.token}&uuid=${userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid}`,
            data: {
                moduleDataList: [{
                        resultKey: mid,
                        moduleVersion: moduleVersion !== null && moduleVersion !== void 0 ? moduleVersion : '1.0.15',
                        moduleName: moduleType,
                        moduleParam: requestParams.body.moduleParam
                    }],
                pageParam: {
                    cityId
                }
            },
            method: 'POST',
            header: {
                'content-type': 'application/json'
            },
            _meituan: {
                mrnChannel: 'hotel'
            },
            success(res) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                if (res.statusCode === 200) {
                    console.log('200', res);
                    comboCallback((_d = (_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.moduleResponseMap) === null || _c === void 0 ? void 0 : _c[mid]) === null || _d === void 0 ? void 0 : _d.moduleData);
                    resolve((_h = (_g = (_f = (_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.moduleResponseMap) === null || _g === void 0 ? void 0 : _g[mid]) === null || _h === void 0 ? void 0 : _h.moduleData);
                }
            },
            fail() {
                console.warn('网络开小差了');
            }
        });
    });
};
export { requestDataCenter };
